import { BOOKING_ENGINE_BASE_URL as u } from "./index52.mjs";
import { BaseApi as l } from "./index165.mjs";
import { formatDateISO8601 as s } from "@amenitiz/design-system";
import { createCartPayload as n } from "./index166.mjs";
import { generateQueryString as m } from "./index167.mjs";
class _ extends l {
  constructor() {
    super(u);
  }
  async getAvailabilities({
    startDate: t,
    endDate: e
  } = {}) {
    const r = "/availability", a = () => {
      const o = new URLSearchParams({
        ...t && { start_date: t },
        ...e && { end_date: e }
      }).toString();
      return o ? `?${o}` : "";
    };
    return (await this.request({
      method: "GET",
      url: `${r}${a()}`
    })).data;
  }
  async getGiftCards() {
    const t = "/gift_cards";
    return (await this.request({
      method: "GET",
      url: `${t}`
    })).data;
  }
  async validatePromoCode(t) {
    return (await this.request({
      method: "POST",
      url: "/promo_codes",
      data: {
        id: t
      }
    })).success;
  }
  async validateGiftCard(t, e) {
    return (await this.request({
      method: "POST",
      url: "/validate_gift_card",
      data: {
        gift_card_code: t,
        client_booking_token: e
      }
    })).success;
  }
  async getRoomAmenities(t) {
    const e = "/room_amenities";
    return (await this.request({
      method: "GET",
      url: `${e}/${t.toString()}`
    })).data;
  }
  async getCountries() {
    const t = "/countries";
    return await this.request({
      method: "GET",
      url: `${t}`
    });
  }
  async getRoomAvailability(t, e, r, a, i, c) {
    const o = "/room_availability", d = new URLSearchParams({
      arrival_date: s(t),
      departure_date: s(e),
      total_adults: r.toString(),
      total_children: a.toString(),
      ...i && { promo_code: i },
      ...c && { room_id: c.toString() }
    }).toString();
    return (await this.request({
      method: "GET",
      url: `${o}?${d}`
    })).data;
  }
  async getExtrasPerRoom(t) {
    const e = m({
      room_id: t.roomId,
      pricing_type_id: t.pricingTypeId,
      promotion_id: t.promotionId,
      arrival_date: s(t.arrivalDate),
      departure_date: s(t.departureDate),
      total_adults: t.totalAdults,
      total_children: t.totalChildren
    });
    return this.request({
      method: "GET",
      url: `/rate_information?${e}`
    });
  }
  async createStripePaymentIntent(t, e) {
    const r = n(t, e), { clientBookingToken: a } = t;
    return this.request({
      method: "POST",
      url: "/generate_stripe_payment",
      data: {
        cart: r,
        client_booking_token: a
      }
    });
  }
  async validateCart(t, e) {
    const r = n(t, e), { clientBookingToken: a } = t;
    return this.request({
      method: "POST",
      url: "/validate_cart_price",
      data: {
        cart: r,
        client_booking_token: a
      }
    });
  }
  async createBooking(t, e) {
    const r = n(t, e), { clientBookingToken: a } = t;
    return this.request({
      method: "POST",
      url: "/create_booking",
      data: {
        cart: r,
        client_booking_token: a
      }
    });
  }
  async getPaymentInformation(t) {
    const e = n(t);
    return this.request({
      method: "POST",
      url: "/payment_information",
      data: {
        cart: e
      }
    });
  }
}
const q = new _();
export {
  _ as Api,
  q as default
};
